import * as React from 'react';
import { Layer } from 'react-map-gl';

import { ILoaderProps } from '../../layer/ILoaderProps';
import { LoadableSource } from '../../layer/LoadableSource';

const PortsNorth = (props: ILoaderProps) => 
  <LoadableSource path="https://apigeostore.longline.co.uk/dataset/96e01b41ed1f163ae86d21d2c365a2fb0fe245a6" {...props}>
    <Layer
      id='ports_north_hover'
      type='circle'
      layout={{ visibility: props.active ? "visible" : "none" }}          
      paint={{ 
        'circle-opacity': [ 'case', ['boolean', ['feature-state', 'hover'], false], 1, 0 ],        
        'circle-color': 'white',
        'circle-radius': 12.5,
        'circle-blur': 0
      }}
    />
    <Layer
      id='ports_north'
      type='symbol'
      layout={{ 
        visibility: props.active ? "visible" : "none",
        'icon-image': 'lle_landing_site-21',
        'icon-size': 1,
        'icon-allow-overlap': true      
      }}
    />    
  </LoadableSource>

export { PortsNorth } 

